const removeNonAlpha = (text: string): string => {
  const nonAlphaRegex = /[^\w\s]/gi;
  const nonAlphaText = text.replace(nonAlphaRegex, '');

  // Remove extra spaces
  const extraSpacesRegex = /\s+/g;
  const cleanedText = nonAlphaText.replace(extraSpacesRegex, ' ').trim();
  return cleanedText;
}

export default removeNonAlpha;
